/**
 * Der Einstieg der Oberfläche.
 *
 * Reihenfolge zählt: `icons` muss vor der ersten Darstellung geladen sein, sonst
 * findet die Komponente `Icon` ihre Symbole nicht.
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import "./icons";
import "./design/styles.css";
// Dann die zwei Töne der zerstörenden Handlung. Sie stehen vor der Grundschicht,
// weil deren Hover-Regeln sie lesen, und außerhalb von `design/`, weil der Skill
// sie in keiner Generation führt (ADR-0025 §2).
import "./tokens/danger.css";
// Die eigene Grundschicht: `.erp-root`, `.erp-scroll` und die Hover-Regeln aus
// #87/#97. Sie liegt außerhalb von `design/`, weil jenes Verzeichnis der Abdruck
// des Skills ist und nicht ergänzt wird — und sie kommt nach ihm, weil sie auf
// seine Token zeigt.
import "./tokens/base.css";
// Danach die Palette der Tönung: Sie zeigt auf die Akzenttoken des Design-Systems
// (ADR-0026) und liegt aus demselben Grund daneben.
import "./tokens/code.css";
import { App } from "./App";
import { applyStoredSkin } from "./shell/skin";

// Die gemerkte Skin **vor** dem ersten Zeichnen (#135): `data-skin` am
// Wurzelelement, gelesen aus `erp-skin`. Sie gehört nicht in die Hülle, denn das
// Anmeldebild steht außerhalb — wer hell gewählt hat, will nicht zuerst ein
// dunkles Anmeldebild sehen.
applyStoredSkin();

const container = document.getElementById("root");

if (container === null) {
  throw new Error("Der Einhängepunkt #root fehlt in der index.html.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
